import FrameComponent from "../ProductReviewsImageFrame/ProductReviewsImageFrame.mjs";
const adapter = (modelData) => {
  const { items = [] } = modelData;
  const filmstripId = `reviews-carousel`;
  const frames = Array.isArray(
    items
  ) ? items.map((item, index) => ({
    key: `reviews-carousel-${index}-${item.reviewIndex}-${item.photoIndex}`,
    props: item
  })) : [];
  const filmstripConfig = {
    component: FrameComponent,
    frames,
    filmstripId,
    description: "Product filmstrip",
    dataAttributes: {
      "data-placement-name": "product-reviews-carousel"
    },
    useDefaultResizeStrategy: true
  };
  return filmstripConfig;
};
export {
  adapter,
  adapter as default
};
//# sourceMappingURL=adapter.mjs.map
